export const apiURL = "https://platform.3sy.dev/api";
export const appHostURL = window.location.host;
export const privacyPolicyLink =
  "https://firebasestorage.googleapis.com/v0/b/sy-website-93038.appspot.com/o/firma%20mail%2FINFORMATIVA%20PRIVACY.pdf?alt=media&token=8b22f7e4-5cb0-43e7-b4c0-7d81bb2f219e";

export const termsAndConditionsLink =
  "https://firebasestorage.googleapis.com/v0/b/sy-website-93038.appspot.com/o/firma%20mail%2FCONDIZIONI%20GENERALI%20DI%20UTILIZZO%20DELLA%20PIATTAFORMA.pdf?alt=media&token=05b5c6aa-5e1a-49a5-ba3f-28e34b64622f";
